import { PropsWithChildren } from 'react';
import { useGetTermsOptions } from '@/hooks/workspace/useGetTermsOptions';
import { useVerifyAuth } from '@/hooks/dbui/useVerifyAuth';
import AcceptTermsDialog from '@/components/acceptTermsDialog/AcceptTermsDialog';

export const VerifyTerms: React.FC<PropsWithChildren> = ({ children }) => {
  const { data: auth } = useVerifyAuth();
  const { data: terms } = useGetTermsOptions(auth.daslWorkspaceId);

  return terms.termsAccepted ? (
    <>{children}</>
  ) : (
    <AcceptTermsDialog daslWorkspaceId={auth.daslWorkspaceId} />
  );
};
